import React, { useState, useContext, useEffect } from "react";
import { AppContext } from "../../../services/context";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../interface_user/header/navbar.css";
import { baseApiUrl } from "../../../services/api";
import Publication from "../publication/userPublication"
import { Table, Modal, Button, notification, Input, Switch } from "antd";



const Header = () => {
  const { user, onUserChange } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState("");

  // -----------------------------------


  const [titre, setTitre] = useState("");
    const [description, setDescription] = useState("");
    const [document, setDocument] = useState(null);
    const [image, setImage] = useState("");
    const [zoneExecution, setZoneExecution] = useState(null);
    const [impactEconomique, setImpactEconomique] = useState(null);
    const [impactSocial, setImpactSocial] = useState(null);
    const [impactEnvironnemental, setImpactEnvironnemental] = useState(null);
    const [video, setVideo] = useState("");
    const [step, setStep] = useState(1);
    const [categoriesOptions, setCategoriesOptions] = useState([]);
    const [projetToDelete, setProjetToDelete] = useState(null);
    const showDeleteModal = (id) => {
      setProjetToDelete(id);
      setIsDeleteModalVisible(true);
    };


    const [projets, setProjets] = useState([]);
    const [publications, setPublications] = useState([]);
    const [isAddModalVisible, setIsAddModalVisible] = useState(false);
    const [isEditModalVisible, setIsEditModalVisible] = useState(false);
    const [isViewModalVisible, setIsViewModalVisible] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingProjet, setEditingProjet] = useState(null);

    const [selectedCategorie, setSelectedCategorie] = useState(null);


    const [currentUser, setCurrentUser] = useState(null); // État pour stocker l'utilisateur

    const openNotificationWithIcon = (type, message) => {
      notification[type]({
        message: message,
      });
    };

    const handleCancelDelete = () => {
      setIsDeleteModalVisible(false);
      setProjetToDelete(null);
    };
    const confirmDelete = async () => {
      if (projetToDelete) {
        await handleDelete(projetToDelete);
        setIsDeleteModalVisible(false);
      }


    };

    const handleDeleteConfirm = (projet) => {
      setDeleteProjet(projet);
      setDeleteModalVisible(true);
    };



    // useEffect(() => {
    //   const token = localStorage.getItem("token"); // Assurez-vous que c'est le bon nom de clé
    //   if (token) {
    //     try {
    //       const decoded = jwtDecode(token); // Utilisation de jwtDecode
    //       setCurrentUser(decoded); // Décodez et stockez les informations de l'utilisateur
    //       console.log("Utilisateur connecté:", decoded); // Vérifiez les informations de l'utilisateur
    //     } catch (error) {
    //       console.error("Erreur lors du décodage du token:", error);
    //     }
    //   } else {
    //     console.warn("Aucun token trouvé dans localStorage."); // Avertir si aucun token n'est trouvé
    //   }

    // }, []);

        const fetchPublications = async () => {
          try {
            const response = await baseApiUrl.get("/publication/liste");
            console.log("Données reçues des publication:", response.data);

            // Vérifie que les données sont bien un tableau avant de les stocker
            setPublications(Array.isArray(response.data) ? response.data : []);
          } catch (error) {
            console.error("Erreur lors de la récupération des questions:", error);
          }
        };


        const fetchCategories = async () => {
          try {
            const response = await baseApiUrl.get(
              "/categorie/liste"
            );

            console.log("donnnnnnnn:",response)

            // Transformer les données pour correspondre au format des options de <Select>
            const options = response.data.map((category) => ({
              value: category.id, // Utiliser l'identifiant ou un autre attribut unique de la catégorie
              label: category.nom, // Utiliser le nom ou un autre attribut descriptif de la catégorie
            }));

            setCategoriesOptions(options);
          } catch (error) {
            console.error("Erreur lors de la récupération des catégories:", error);
          }
        };

        useEffect(() => {
          fetchCategories();
          fetchPublications();
        }, []);

 const handleAddProjet = async (e) => {
      e.preventDefault();

      if (!titre) {
        openNotificationWithIcon("error", "Veuillez remplir tous les champs.");
        return;
      }

      try {
        const formData = new FormData();

        const projetData = {
          titre,
          description,
          // description2,
          // description3,
          categorieId: selectedCategorie,
          zoneExecution,
          impactEconomique,
          impactEnvironnemental,
          impactSocial,


        };

        formData.append("publication", new Blob([JSON.stringify(projetData)], {
          type: "application/json"
        }));

        if (document) {
          formData.append("document", document);
        }
        if (image) {
          formData.append("image", image);
        }
        if (video) {
          formData.append("video", video);
        }

        console.log("Données du publication:", projetData);

        console.log("Données du date:", formData);


        // ✅ Correction de l'appel API avec Axios
        const response = await baseApiUrl.post("/publication/create", formData);

        // ✅ Récupération correcte des données
        const newProjet = response.data;

        console.log("Réponse API:", newProjet);

        setProjets([newProjet, ...projets]);

        console.log("Réponse API:", newProjet);

        // ✅ Notification de succès
        openNotificationWithIcon("success", "Publication ajouté avec succès.");
        fetchPublications();
      } catch (error) {
        openNotificationWithIcon("error", "Erreur lors de l'ajout du pubblication.");
        console.error("Erreur détectée:", error.response?.data || error.message || error);
      }

      resetForm();
    };






    const resetForm = () => {
      setStep(1);
      setIsEditMode(false);
      setEditingProjet(null);
      setIsAddModalVisible(false);
      setIsEditModalVisible(false);
      setIsViewModalVisible(false);
      setTitre("");
      setDescription("");
      setSelectedCategorie("");
      setImage("");
      setDocument("");

      setZoneExecution("");
      setImpactEconomique("");
      setImpactEnvironnemental("");
      setImpactSocial("")


      setIsEditMode(false);
      setEditingProjet(null);
      setIsAddModalVisible(false);
      setIsEditModalVisible(false);
      setIsViewModalVisible(false);
    };



    const handleNext = () => {
      setStep(step + 1);
    };

    const handlePrevious = () => {
      setStep(step - 1);
    };



  // ------------------------------------

  useEffect(() => {
    setActiveKey(location.pathname);
    console.log("Chemin actuel:", location.pathname);
  }, [location]);

 const handleLogout = async () => {
    // Récupérer le token du localStorage
    const token = localStorage.getItem("token");

    if (token) {
      try {
        // Envoyer une requête de déconnexion à l'API
        await baseApiUrl.post(
          "/compte/deconnexion",
        );
        console.log("Déconnexion réussie sur le serveur");
      } catch (error) {
        console.error("Erreur lors de la déconnexion sur le serveur:", error);
      }
    } else {
      console.warn("Aucun token trouvé pour la déconnexion.");
    }

    // Supprimer les tokens et réinitialiser l'utilisateur dans le contexte
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    onUserChange({
      isAuth: false,
      roles: [],
      profile: "",
      name: null,
      token: null,
      refreshToken: null,
    });

    // Rediriger vers la page d'accueil
    navigate("/");
  };

  const activeStyle = {
    color: "#2ecc71",
    fontWeight: "bold",
    borderBottom: "2px solid #2ecc71"
  };

  return (
    <Navbar expand="lg" className="menu-main-bg" sticky="top">
    <Container>
      <Navbar.Brand as={Link} to="/" className="mx-auto">
        <img
          src={`${process.env.PUBLIC_URL}/assets/img/logo/ab2i.jpg`}
          alt="vexon"
          height="50"
        />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center">
        <Nav activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
          <Nav.Link
            as={Link}
            to="/"
            style={activeKey === "/" ? { ...activeStyle, fontWeight: "bold" } : { fontWeight: "bold" }}
            className="nav-item"
          >
            Accueil
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/Projets"
            style={activeKey === "/Projets" ? { ...activeStyle, fontWeight: "bold" } : { fontWeight: "bold" }}
            className="nav-item"
          >
            Projets
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/Publications"
            style={activeKey === "/Publications" ? { ...activeStyle, fontWeight: "bold" } : { fontWeight: "bold" }}
            className="nav-item"
          >
            Publications
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/Informations"
            style={activeKey === "/Informations" ? { ...activeStyle, fontWeight: "bold" } : { fontWeight: "bold" }}
            className="nav-item"
          >
            Actualités
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/forums"
            style={activeKey === "/forums" ? { ...activeStyle, fontWeight: "bold" } : { fontWeight: "bold" }}
            className="nav-item"
          >
            Forums
          </Nav.Link>
          <NavDropdown
            title={<span style={{ fontWeight: "bold" }}>Contact</span>}
            id="basic-nav-dropdown"
            className={
              activeKey === "/apropos" || activeKey === "/contact"
                ? "active-dropdown"
                : ""
            }
          >
            <NavDropdown.Item
              as={Link}
              to="/apropos"
              style={activeKey === "/apropos" ? { ...activeStyle, fontWeight: "bold" } : { fontWeight: "bold" }}
            >
              À propos
            </NavDropdown.Item>
            <NavDropdown.Item
              as={Link}
              to="/contact"
              style={activeKey === "/contact" ? { ...activeStyle, fontWeight: "bold" } : { fontWeight: "bold" }}
            >
              Nous Contacter
            </NavDropdown.Item>

          <NavDropdown.Item
              as={Link}
              to="/besoin"
              style={activeKey === "/besoin" ? { ...activeStyle, fontWeight: "bold" } : { fontWeight: "bold" }}
            >
              Vos besoins
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
        {/* Bouton Se connecter en bas pour petits écrans */}
        {!user.isAuth && (
          <div className="d-lg-none mt-3">
            <Nav.Link
              as={Link}
              to="/loginUser"
              className="btn"
              style={{
                backgroundColor: "green",
                color: "white",
                fontWeight: "bold",
                textAlign: "center",
                padding: "10px 20px",
                borderRadius: "5px",
                display: "block",
              }}
            >
              Se connecter
            </Nav.Link>
          </div>
        )}
      </Navbar.Collapse>
      {/* Bouton Se connecter pour grands écrans */}
      {!user.isAuth && (
        <div className="d-none d-lg-block ms-auto">
          <Nav.Link
            as={Link}
            to="/loginUser"
            className="btn"
            style={{
              backgroundColor: "green",
              color: "white",
              fontWeight: "bold",
              padding: "5px 15px",
              borderRadius: "5px",
            }}
          >
            Se connecter
          </Nav.Link>
        </div>
      )}

<Modal
              title="Ajouter une publication"
              visible={isAddModalVisible}
              onCancel={() => setIsAddModalVisible(false)}
              width={900}
            >
              <form onSubmit={handleAddProjet}>
                {step === 1 && (
                  <>
                    <div className="row">
                      <div className="col-sm-6 col-12">
                        <div className="form-group">
                          <label>Titre de la publication</label>
                          <input
                            type="text"
                            className="form-control"
                            value={titre}
                            onChange={(e) => setTitre(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-12">
                        <div className="form-group">
                          <label>Zone d'exécution</label>
                          <textarea
                            type="text"
                            className="form-control"
                            value={zoneExecution}
                            onChange={(e) => setZoneExecution(e.target.value)}
                            style={{ width: "100%", height: "100px" }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6 col-12">
                        <div className="form-group">
                          <label>Impact économique</label>
                          <textarea
                            type="text"
                            className="form-control"
                            value={impactEconomique}
                            onChange={(e) => setImpactEconomique(e.target.value)}
                            style={{ width: "100%", height: "100px" }}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-12">
                        <div className="form-group">
                          <label>Description de la publication</label>
                          <textarea
                            type="text"
                            className="form-control"
                            value={description}
                            onChange={(e) =>
                              setDescription(e.target.value)
                            }
                            style={{ width: "100%", height: "100px" }}
                          />
                        </div>
                      </div>
                    </div>


                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleNext}
                    >
                      Suivant
                    </button>
                  </>
                )}

                {step === 2 && (
                  <>


                    <div className="row">
                      <div className="col-sm-6 col-12">
                        <div className="form-group">
                          <label>Domaine de la publication</label>
                          <select
                            className="form-control"
                            value={selectedCategorie}
                            onChange={(e) => setSelectedCategorie(Number(e.target.value))}                        >
                            <option value="">Sélectionnez un domaine...</option>
                            {/* Valeur par défaut */}
                            {categoriesOptions.map((category) => (
                              <option key={category.value} value={category.value}>
                                {category.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6 col-12">
                        <div className="form-group">
                          <label>Impact environnemental</label>
                          <textarea
                            type="text"
                            className="form-control"
                            value={impactEnvironnemental}
                            onChange={(e) => setImpactEnvironnemental(e.target.value)}
                            style={{ width: "100%", height: "100px" }}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-12">
                        <div className="form-group">
                          <label>Impact Social</label>
                          <textarea
                            type="text"
                            className="form-control"
                            value={impactSocial}
                            onChange={(e) => setImpactSocial(e.target.value)}
                            style={{ width: "100%", height: "100px" }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6 col-12">
                        <div className="form-group">
                          <label>Document du publication</label>
                          <input
                            type="file"
                            className="form-control"
                            onChange={(e) => setDocument(e.target.files[0])}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-12">
                        <div className="form-group">
                          <label>Image de la publication</label>
                          <input
                            type="file"
                            className="form-control"
                            onChange={(e) => setImage(e.target.files[0])}
                          />
                        </div>
                      </div>
                    </div>



                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handlePrevious}
                    >
                      Précédent
                    </button>

                    <button
                      type="submit"
                      className="btn btn-primary"

                    >
                      Créer
                    </button>
                  </>
                )}
              </form>
            </Modal>
      {/* Menu utilisateur pour les utilisateurs connectés */}
      {user.isAuth && (
        <NavDropdown
          title={
            <>
              <img
                src={
                  user.photo
                    ? baseApiUrl.defaults.baseURL +`/image/${user.photo}`
                    : "default-image.jpg"
                }
                alt="Profil"
                className="rounded-circle"
                width="40"
              />
              {user.name}
            </>
          }
          id="user-dropdown"
        >
          <NavDropdown.Item
            as={Link}
            to="/profileUser"
            style={activeKey === "/profileUser" ? { ...activeStyle, fontWeight: "bold" } : { fontWeight: "bold" }}
          >
            Mon profile
          </NavDropdown.Item>

          <NavDropdown.Item
           onClick={() => {
            resetForm();
            setIsAddModalVisible(true);
          }}
            as={Link}

            // style={activeKey === "/userPublication" ? { ...activeStyle, fontWeight: "bold" } : { fontWeight: "bold" }}
          >
            Faire une publication
          </NavDropdown.Item>



          <NavDropdown.Divider />
          <NavDropdown.Item onClick={handleLogout}>
            Se déconnecter
          </NavDropdown.Item>
        </NavDropdown>
      )}
    </Container>
  </Navbar>




  );


};

export default Header;
